/** Форматирование чисел/времени и копирование в буфер обмена. */

/** Секунды → «мм:сс» (например 75 → «01:15»). */
export function formatTimer(totalSeconds) {
  const s = Math.max(0, Math.floor(Number(totalSeconds) || 0));
  const mm = String(Math.floor(s / 60)).padStart(2, "0");
  const ss = String(s % 60).padStart(2, "0");
  return `${mm}:${ss}`;
}

/** Число с пробелами-разделителями тысяч: 12345 → «12 345». */
export function formatNumber(n) {
  return new Intl.NumberFormat("ru-RU").format(Number(n) || 0);
}

/** Форма слова по числу: pluralRu(5, "игрок", "игрока", "игроков") → «игроков». */
export function pluralRu(n, one, few, many) {
  const abs = Math.abs(Math.floor(Number(n) || 0));
  const mod10 = abs % 10;
  const mod100 = abs % 100;
  if (mod10 === 1 && mod100 !== 11) return one;
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return few;
  return many;
}

/**
 * Скопировать текст в буфер обмена (с фолбэком через textarea).
 * @returns {Promise<boolean>} удалось ли
 */
export async function copyText(text) {
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch (e) {
    // падаем в фолбэк ниже
  }
  try {
    const area = document.createElement("textarea");
    area.value = text;
    area.setAttribute("readonly", "");
    area.style.position = "fixed";
    area.style.opacity = "0";
    document.body.appendChild(area);
    area.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(area);
    return ok;
  } catch (e) {
    return false;
  }
}

/** true, если пользователь просит меньше анимаций. */
export function prefersReducedMotion() {
  return typeof window !== "undefined" && !!window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}
